<template>
  <el-dialog title="依图软件许可协议" :visible="visible" width="80%" top="5vh" destroy-on-close @close="handelClose">
    <div class="protocolModel">
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: center;
          line-height: 37.5pt;
        "
      >
        <span style="font-family: '宋体'; font-size: 14pt; font-weight: bold"
          >依</span
        ><span style="font-family: '宋体'; font-size: 14pt; font-weight: bold"
          >图软件</span
        ><span style="font-family: '宋体'; font-size: 14pt; font-weight: bold"
          >许可协议</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">导言</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">欢迎</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">使用</span
        ><span style="font-family: '宋体'; font-weight: bold">依图软件</span
        ><span style="font-family: '宋体'; font-weight: bold">！</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">为使用</span
        ><span style="font-family: '宋体'; font-weight: bold">依图软件</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >（以下简称“本软件”），</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >应当阅读并遵守《</span
        ><span style="font-family: '宋体'; font-weight: bold">依图软件</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >许可协议》（以下简称“本协议”）。请</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。限制、免责条款可能以加粗等形式提示</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">注意。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">除非</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >已阅读并接受本协议所有条款，否则</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >无权下载、安装或使用本软件。</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >的下载、安装、使用等行为即视为</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >已阅读并同意上述协议的约束。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >一、协议的范围</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">1.1 协议适用主体范围</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">本协议是</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">与</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">之间关于</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >下载、安装、使用、复制本软件所订立的协议。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">1.2 协议关系及冲突条款</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">本协议内容同时包括</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">可能不断发布的关于本</span
        ><span style="font-family: '宋体'">软件</span
        ><span style="font-family: '宋体'"
          >的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">同样</span
        ><span style="font-family: '宋体'">应当遵守。</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">二、关于本</span
        ><span style="font-family: '宋体'; font-weight: bold">软件</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.1 本</span
        ><span style="font-family: '宋体'">软件内容</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'">.1对于</span
        ><span style="font-family: '宋体'">本</span
        ><span style="font-family: '宋体'">软件，</span
        ><span style="font-family: '宋体'">依</span
        ><span style="font-family: '宋体'">图</span
        ><span style="font-family: '宋体'">给予</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">一项不可转让及非排他性的许可。</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">仅可</span
        ><span style="font-family: '宋体'">在依图生产制造的服务器上</span
        ><span style="font-family: '宋体'">使用这些软件及服务。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'">.2 本软件可能提供包括</span
        ><span style="font-family: '宋体'">针对不同服务器的不同</span
        ><span style="font-family: '宋体'">应用版本，</span
        ><span style="font-family: '宋体'"
          >购买或者使用依图生产制造的服务器的</span
        ><span style="font-family: '宋体'">用户必须选择与所安装</span
        ><span style="font-family: '宋体'">服务器</span
        ><span style="font-family: '宋体'">相匹配的软件</span
        ><span style="font-family: '宋体'">类型及软件</span
        ><span style="font-family: '宋体'">版本。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">2</span
        ><span style="font-family: '宋体'"> </span
        ><span style="font-family: '宋体'">本服务</span
        ><span style="font-family: '宋体'">许可的范围</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">2</span
        ><span style="font-family: '宋体'">.1 </span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">给予</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >一项不可转让及非排他性的许可，以使用本软件。</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">可以在</span
        ><span style="font-family: '宋体'">依图生产制造的服务器</span
        ><span style="font-family: '宋体'">上安装、使用、运行本软件。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">2</span
        ><span style="font-family: '宋体'">.2 </span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">2.</span
        ><span style="font-family: '宋体'">2</span
        ><span style="font-family: '宋体'"
          >.3 本条及本协议其他条款未明示授权的其他一切权利仍由</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">保留，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">在行使这些权利时须另外取得</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">的书面许可。</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >如果未行使前述任何权利，并不构成对该权利的放弃。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >三、软件的获取</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">3.1 </span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">可以直接从</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >的网站上获取本软件，也可以从得到</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">授权的第三方</span
        ><span style="font-family: '宋体'">处</span
        ><span style="font-family: '宋体'">获取。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">3.2 如果</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">从未经</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">授权的第三方</span
        ><span style="font-family: '宋体'; font-weight: bold">处</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >获取本软件或与本软件名称相同的安装程序，</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >无法保证该软件能够正常使用，并对因此给</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >造成的损失不予负责。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >四、软件的安装与卸载</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">4.1 </span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">可能为不同的</span
        ><span style="font-family: '宋体'; font-weight: bold">服务器</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >开发了不同的软件版本，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >应当根据实际情况选择下载合适的版本进行安装。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">4.2 下载安装程序后，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >需要按照该程序提示的步骤正确安装。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'"
          >4.3 为提供更加优质、安全的服务，在本软件安装时</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">可能推荐</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">安装其他软件，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">可以选择安装或不安装。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">4.4 如果</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">愿意帮助</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">改进产品服务，请</span
        ><span style="font-family: '宋体'">通过依图的网站联系依图</span
        ><span style="font-family: '宋体'">。</span>
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >五、软件的更新</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'"
          >5.1 为了改善用户体验、完善服务内容，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">将不断努力开发新的</span
        ><span style="font-family: '宋体'">软件</span
        ><span style="font-family: '宋体'">，并为</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'"
          >5.2 为了保证本软件及服务的安全性和功能的一致性，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >有权对软件的部分功能效果进行改变或限制。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >六、用户信息保护</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">6.1 保护用户</span
        ><span style="font-family: '宋体'">的数据和</span
        ><span style="font-family: '宋体'">信息是</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">的一项基本原则，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">将会采取合理的措施保护用户的</span
        ><span style="font-family: '宋体'">数据和</span
        ><span style="font-family: '宋体'"
          >信息。除法律法规规定的情形外，未经用户许可</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">不会向第三方公开、透露用户</span
        ><span style="font-family: '宋体'">数据和</span
        ><span style="font-family: '宋体'">信息。</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >对相关信息采用专业加密存储与传输方式，保障用户</span
        ><span style="font-family: '宋体'">的</span
        ><span style="font-family: '宋体'">信息安全。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">6.</span
        ><span style="font-family: '宋体'">2</span
        ><span style="font-family: '宋体'"> 未经</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">的同意，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">不会向</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">以外的任何公司、组织和个人披露</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">的</span
        ><span style="font-family: '宋体'">数据和</span
        ><span style="font-family: '宋体'"
          >信息，但法律法规另有规定的除外。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">七</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >、用户行为规范</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">
          软件使用规范</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1 除非法律允许或</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">书面许可，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >使用本软件过程中不得从事下列行为：</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.1 删除本软件及其副本上关于著作权的信息；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.2
          对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">.1.3 对</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.4
          对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >经授权的第三方工具/服务接入本软件和相关系统；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.5
          通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">.1.6 通过非</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >开发、授权的第三方软件、插件、外挂、系统，登录或使用</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >软件及服务，或制作、发布、传播上述工具；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.7
          自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.1.8 其他未经</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >明示授权的行为。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">2</span
        ><span style="font-family: '宋体'; font-weight: bold">
          对自己行为负责</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >充分了解并同意，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">必须为自己</span
        ><span style="font-family: '宋体'; font-weight: bold">使用本软件</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >一切行为负责，以及由此产生的任何后果。</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >无法且不会对因前述风险而导致的任何损失或损害承担责任。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">3</span
        ><span style="font-family: '宋体'; font-weight: bold"> 违约处理</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">3</span
        ><span style="font-family: '宋体'; font-weight: bold">.1</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">理解并同意，</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">有权</span
        ><span style="font-family: '宋体'; font-weight: bold">依合理</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告和配合调查等，用户应独自承担由此而产生的一切法律责任。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">7</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">3</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">2</span
        ><span style="font-family: '宋体'; font-weight: bold"> </span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >理解并同意，因</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >应当独立承担责任；</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >因此遭受损失的，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >也应当一并赔偿。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">八</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >、知识产权声明</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">8</span
        ><span style="font-family: '宋体'">.1 </span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">8</span
        ><span style="font-family: '宋体'">.2 未经</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'">或相关权利人书面同意，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">不得</span
        ><span style="font-family: '宋体'"
          >为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">九</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >、终端安全责任</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">9</span
        ><span style="font-family: '宋体'">.1 </span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'"
          >理解并同意，本软件可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，</span
        ><span style="font-family: '宋体'">威胁</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">的</span
        ><span style="font-family: '宋体'">服务器</span
        ><span style="font-family: '宋体'"
          >信息和数据安全，继而影响本软件的正常使用等。因此，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">应加强信息安全及</span
        ><span style="font-family: '宋体'">网络安全</span
        ><span style="font-family: '宋体'">，以免遭受损失。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">9</span
        ><span style="font-family: '宋体'; font-weight: bold">.</span
        ><span style="font-family: '宋体'; font-weight: bold">2</span
        ><span style="font-family: '宋体'; font-weight: bold">
          维护软件安全与正常使用是</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">和</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">的共同责任，</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >将按照行业标准合理审慎地采取必要技术措施保护</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">的</span
        ><span style="font-family: '宋体'; font-weight: bold">服务器</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >信息和数据安全，但是</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">承认和同意</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >并不能就此提供完全保证。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">十</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >、第三方软件</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'">0</span
        ><span style="font-family: '宋体'"
          >.1
          本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'">0</span
        ><span style="font-family: '宋体'"
          >.2 本软件如果使用了第三方的软件或技术，</span
        ><span style="font-family: '宋体'">依图</span
        ><span style="font-family: '宋体'"
          >将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过</span
        ><span style="font-family: '宋体'">开源软件</span
        ><span style="font-family: '宋体'"
          >页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，</span
        ><span style="font-family: '宋体'">您</span
        ><span style="font-family: '宋体'">应当遵守这些要求。</span
        ><span style="font-family: '宋体'; font-weight: bold">如果</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >没有遵守这些要求，该第三方或者国家机关可能会对</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >提起诉讼、罚款或采取其他制裁措施，并要求</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold">给予协助，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >应当自行承担法律责任。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">0</span
        ><span style="font-family: '宋体'; font-weight: bold">.3 </span
        ><span style="font-family: '宋体'; font-weight: bold">本</span
        ><span style="font-family: '宋体'; font-weight: bold">网站链接</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >到第三方网站的</span
        ><span style="font-family: '宋体'; font-weight: bold">链接仅</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >作为一种方便服务提供给您。如果使用这些链接，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">将离开本</span
        ><span style="font-family: '宋体'; font-weight: bold">网站</span
        ><span style="font-family: '宋体'; font-weight: bold">。</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >没有审查过任何第三方网站，对这些网站及其内容不进行控制，也不负任何责任。如果</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >决定访问任何与本</span
        ><span style="font-family: '宋体'; font-weight: bold">网站</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >链接的第三方网站，其可能带来的结果和风险全部由</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">自己承担。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">10.4 </span
        ><span style="font-family: '宋体'; font-weight: bold"
          >如因本软件使用的第三方软件或技术</span
        ><span style="font-family: '宋体'; font-weight: bold">，或者</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >从第三方网站下载第三方软件</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >引发的任何纠纷，应由该第三方负责解决，</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >不承担任何责任。</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >不对第三方软件或技术提供客服支持，若</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >需要获取支持，请与第三方联系。</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">十</span
        ><span style="font-family: '宋体'; font-weight: bold">一</span
        ><span style="font-family: '宋体'; font-weight: bold">、其他</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">.1</span
        ><span style="font-family: '宋体'; font-weight: bold">&#xa0;</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >使用本软件即视为</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >已阅读并同意受本协议的约束。</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >有权在必要时修改本协议条款。</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >继续使用本软件，即视为</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >已接受修改后的协议。如果</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >不接受修改后的协议，应当停止使用本软件。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.2 本协议签订地为中华人民共和国</span
        ><span style="font-family: '宋体'; font-weight: bold">上海市徐汇区</span
        ><span style="font-family: '宋体'; font-weight: bold">。</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.3
          本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">.4 若</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold">和</span
        ><span style="font-family: '宋体'; font-weight: bold">依图</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，</span
        ><span style="font-family: '宋体'; font-weight: bold">您</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'">1</span
        ><span style="font-family: '宋体'"
          >.5
          本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.6
          本协议可能存在包括中文、英文在内的多种语言的版本，如果存在中文版本与其他语言的版本相冲突的地方，以中文版本为准。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold">1</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >.7
          本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方</span
        ><span style="font-family: '宋体'; font-weight: bold">均</span
        ><span style="font-family: '宋体'; font-weight: bold"
          >具有约束力。</span
        >
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: justify;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">(完)</span>
      </p>
      <p
        style="
          margin-top: 18pt;
          margin-bottom: 18pt;
          text-align: right;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'; font-weight: bold"
          >上海依图网络科技有限公司</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          widows: 0;
          orphans: 0;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: '宋体'">&#xa0;</span>
      </p>
    </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'tecContent',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    closeModel: Function,
  },
  computed: {
    
  },
  data() {
    return {
    };
  },

  methods: {
    handelClose(){
      console.log('之１２３３４')
      this.$emit('closeModel')
    }
  }
};
</script>

<style scoped>
.protocolModel {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
</style>